import React from 'react';
import styled, { css } from 'styled-components';
import styleGenerator from '../../utils/styles/utils/styleGenerator';

type Props = {
  all?: number;
  top?: number;
  right?: number;
  bottom?: number;
  left?: number;
  vertical?: number;
  horizontal?: number;
};

const spec = [
  props => ({
    loop: ['all', 'top', 'right', 'bottom', 'left', 'horizontal', 'vertical'],
    key: [
      ['padding-top', 'padding-right', 'padding-bottom', 'padding-left'],
      ['padding-top'],
      ['padding-right'],
      ['padding-bottom'],
      ['padding-left'],
      ['padding-left', 'padding-right'],
      ['padding-top', 'padding-bottom']
    ],
    value: ({ loop }) => `${props[loop]}px`
  })
];

const PaddingWrapper = styled.div<Props>`
  ${styleGenerator(spec)}
`;

const Padding: React.FC<Props> = ({
  all,
  top,
  right,
  bottom,
  left,
  vertical,
  horizontal,
  children,
  ...rest
}) => (
  <PaddingWrapper
    all={all}
    top={top}
    right={right}
    bottom={bottom}
    left={left}
    vertical={vertical}
    horizontal={horizontal}
    {...rest}
  >
    {children}
  </PaddingWrapper>
);

export default Padding;
